module.exports = __webpack_public_path__ + "kh.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/kh.svg
// module id = 891
// module chunks = 0